import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-aios-sm border-[1.5px] border-iai-border bg-background px-3.5 py-2 text-base transition-all duration-150 placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-2 focus-visible:border-iai-purple disabled:cursor-not-allowed disabled:opacity-50 md:text-sm overflow-y-hidden focus:overflow-y-auto",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
